import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Observable, Subject, takeUntil } from "rxjs";
import { CartState } from "src/app/core/cart/state/cart.state";
import { Select } from "@ngxs/store";
import { CommonModule } from "@angular/common";
import { MatBadgeModule } from "@angular/material/badge";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { AccountState } from "src/app/core/account/state/account.state";
import { Account } from "src/app/core/account/model/account.model";

const materialModules = [MatBadgeModule];

@Component({
  standalone: true,
  selector: "app-mobile-menu",
  templateUrl: "./mobile-menu.component.html",
  styleUrls: ["./mobile-menu.component.scss"],
  imports: [CommonModule, TranslateModule, RouterModule, ...materialModules]})
export class MobileMenuComponent implements OnInit, OnDestroy {
  @Select(AccountState.account) account$: Observable<Account>;
  @Select(CartState.totalItems) totalItems$: Observable<number>;

  public menuItem: any[];

  private destroy$ = new Subject<void>();

  constructor(private _router: Router) {}

  ngOnInit(): void {
    this.account$.pipe(takeUntil(this.destroy$)).subscribe(
      (account) =>
        (this.menuItem = [
          {
            id: 1,
            active: true,
            title: "menu_home",
            icon: "ri-home-3",
            path: "/home",
            match: ["home"]},
          {
            id: 2,
            active: false,
            title: "menu_streamers",
            icon: "ri-team",
            path: "/creators",
            match: ["streamers"]},
          {
            id: 3,
            active: false,
            title: "menu_cart",
            icon: "ri-shopping-cart",
            path: "/shop/cart",
            match: ["shop"]},
          {
            id: 4,
            active: false,
            title: "menu_account",
            icon: "ri-account-circle",
            path: account ? "/account/profile" : "/auth/login",
            match: ["account", "auth"]}]),
    );
    this.addRouterListener();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private addRouterListener(): void {
    this._router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateActiveMenu(event.urlAfterRedirects.split("/")[1]);
      }
    });
  }

  updateActiveMenu(currentUrl: string) {
    this.menuItem.forEach((item) => {
      item.active = item.match.includes(currentUrl);
    });
  }
}
